import axios from 'axios';

const service = axios.create({
  proxy: true,
  timeout: 6000,
  baseURL: getFileServerUrl(),
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

service.interceptors.response.use(
  response => response,
  error => {
    console.log('err' + error);
    return Promise.reject(error)
  });

export default service



// WEBPACK FOOTER //
// ./src/common/file-request.js